import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Coperator(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>C Operator tutorial For Beginners</title>
 <meta name="description" content="C Operator tutorial for beginners.Operators in C are used special symbols which perform any type of operations.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c operator,c operators,c operator precedence,logical operators in c,c operator order,modulo operator in c,or operator in c,c operator or,and operator in c" />
 <link rel="canonical" href="https://www.codeexampler.com/c-operator" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Operator in C</h1>
    <div className="first">
        <a href="/c-literal">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-What is Operator in C?</h2>
    <p className="mt-4 para">Operators in C are using special symbols which perform any operations.<br/>
or<br/>
The C and operator is a special symbol that is using in the expression.
</p>


<h2 className='headings'>Operator in C Syntax code</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> 160 </span>
                <span className="qwerty-3">/</span>
                <span className="qwerty-10"> 160 </span>
                <span className="qwerty-3">%</span>
                <span className="qwerty-10"> 160 </span>
            {"\n"}{"\n"}    
                
            </code>
          </pre>
          </div>  
          <h4 className='headings'>Answer : </h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3"> (+ - / %)  </span>
            {"\n"}{"\n"}    
                <span className="qwerty-11"> this is an operator</span>  
            </code>{"\n"}{"\n"}
          </pre>
          </div>  



<h2 className='headings'>Operator in C Syntax code</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> int </span>
                <span className="qwerty-10">a </span>
                <span className="qwerty-3">= </span>
                <span className="qwerty-10">b </span>
                <span className="qwerty-11">+ </span>
                <span className="qwerty-10">c </span>
            {"\n"}{"\n"}    
            </code>
          </pre>
          </div>    
          <h4 className='headings'>Output :</h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3">( + , = )</span>
                <span className="qwerty-6">  there are 2 operators </span>
                {"\n"}{"\n"}    
                <span className="qwerty-10">( b, c, d) </span>
                <span className="qwerty-6">there re 3 operands </span>
                        {"\n"}{"\n"}    
            </code>
          </pre>
          </div>




<h2 className='headings'>Operator in C Syntax code</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> b </span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-10"> c </span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-10"> d</span>
                <span className="qwerty-3" >;</span>
            {"\n"}{"\n"}     </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">( + , = )</span>
                        <span className="qwerty-6"> there are 2 operators</span>
                        {"\n"}{"\n"}
                        <span className="qwerty-10">( b, c, d,)</span>
                        <span className="qwerty-6"> there are 3 operands</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>


<h2 className="mt-4 mh2">C Operator Example</h2>


<h2 className="mt-4 mh2">1, Arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>



<h2 className='headings'>Q-Write a program add a and b ,and print C?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">,</span>  
                <span className="qwerty-10">c</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}                
                <span className="qwerty-10">     a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 8</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
                <span className="qwerty-10">     b </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 4</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
                <span className="qwerty-10">     c </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-10"> c </span>
                <span className="qwerty-3">);</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
                <span className="qwerty-4" >&#125;</span>
                {"\n"}{"\n"}
        </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">12</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>




<h2 className='headings'>C Operator Example code:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10">     C </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty">-</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}  
            <span className="qwerty-10">     C </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty">*</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
            <span className="qwerty-10">     C </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty">/</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
            <span className="qwerty-10">     C </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty">%</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
            <span className="qwerty-10">     C </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty">++</span>
                <span className="qwerty-8"> OR </span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty">--</span>
                <span className="qwerty-3"> ;</span>         
            {"\n"}{"\n"}                
            <span className="qwerty-10">     C </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty">++</span>
                <span className="qwerty-8"> OR </span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty">--</span>
                <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}   
        </code>
        </pre>
        </div>  


<h2 className="mt-4 mh2">2,Relational operator:</h2>
<h3 className="mt-4 mh3"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>

<h2 className="mt-4 mh2">C Relational Operator Example</h2>


<h2 className='headings'>Q-Write a program if a is greater than b, so print C Operator Example Code?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}                
                <span className="qwerty-10">     a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 10</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
                <span className="qwerty-10">     b </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 20</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
                <span className="qwerty-6">     if</span>
                <span className="qwerty-3">( </span>
                <span className="qwerty-10">a</span>
                <span className="qwerty"> &#60; </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3"> )</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-10"> b is greater </span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">);</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
                <span className="qwerty-4" >&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10"> b is greater</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>


<h2 className="mt-4 mh2">C Relational Operator Example</h2>




<h2 className='headings'>Q-Write a program a and b, if both are equal, print in C Operator Example code?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}                
                <span className="qwerty-10">     a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 20</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
                <span className="qwerty-10">     b </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 20</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
                <span className="qwerty-6">     if</span>
                <span className="qwerty-3">( </span>
                <span className="qwerty-10">a</span>
                <span className="qwerty"> &#60;= </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3"> )</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-10"> both equal </span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">);</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
                <span className="qwerty-4" >&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"500vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10"> both equal</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>

<h2 className="mt-4 mh2">3,logic operator:</h2>
<h3 className="mt-4 mh3">And  &#38;&#38;<br/>
Or   &#124;&#124;<br/>
Not&#33;
</h3>



<h2 className='headings'>Q-Write a program C Operator Example code?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}                
                <span className="qwerty-10">     a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 20</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
                <span className="qwerty-10">     b </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 20</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
                <span className="qwerty-6">     if</span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-3"> = </span>
                <span className="qwerty-9"> 20 </span>
                <span className="qwerty"> && </span>
                <span className="qwerty-10">b</span>                
                <span className="qwerty-3"> = </span>
                <span className="qwerty-9"> 20</span>
                <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-10"> both equal </span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">);</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
                <span className="qwerty-4" >&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10"> both equal</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>

<h2 className="mt-4 mh2">4, Bitwise operator:</h2>
<h3 className="mt-4 mh">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>

<h2 className="mt-4 mh2">6, Identifier operator in C:</h2>


<h2 className='headings'>Q-Write a Program multiply int a in C Operator Example code?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}                
                <span className="qwerty-10">     a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-9"> 5</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
               
            <span className="qwerty-10">     a</span>                
                <span className="qwerty-3"> = </span>
            <span className="qwerty-10">a</span>
                <span className="qwerty"> * </span>
                <span className="qwerty-9">4</span>
                <span className="qwerty-3">;</span>
                {"\n"}{"\n"}        
                <span className="qwerty-8">     OR</span>
                {"\n"}{"\n"}        
                <span className="qwerty-10">     a</span>
                <span className="qwerty"> *</span>
                <span className="qwerty-3"> = </span>
                <span className="qwerty-9">4</span>
                <span className="qwerty-3">;</span>
            {"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-3">);</span>
                       {"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}
                <span className="qwerty-4" >&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10"> 20</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
  </div>        

<h2 className="mt-4 mh2">7, The conditional operator (?:) in C:
</h2>
<p className="mt-4 para">1, A conditional operator is known as a ternary operator.<br/>
2, The main point is that this Conditional operator  consists of three operands.<br/>
</p>



<div>      
    <h2 className='headings'>C conditional Operator Syntax code</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
          {"\n"}
                <span className="qwerty-5"> Variable </span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty-3"> = </span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-6">expression</span>
                <span className="qwerty-3">)</span>
                <span className="qwerty">?</span>
                <span className="qwerty-7"> true </span>
                <span className="qwerty">:</span>
                <span className="qwerty-7"> false </span> 
              
            </code>
            {"\n"}  {"\n"}
          </pre>
          </div>  
       
                              
    </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-literal">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
</div>
    </div>
)

}
export default Coperator;